import React, { useEffect, useState } from 'react';
import Fade from '@material-ui/core/Fade';
import { Spinner } from '../../StyledComponent';
import { getTimeline } from '../../../services/meuImovel';
import Step1 from '../../../assets/novosicones/MeuImovel/timeline/step_1.svg';
import Step2 from '../../../assets/novosicones/MeuImovel/timeline/step_2.svg';
import Step3 from '../../../assets/novosicones/MeuImovel/timeline/step_3.svg';
import Step4 from '../../../assets/novosicones/MeuImovel/timeline/step_4.svg';
import Step5 from '../../../assets/novosicones/MeuImovel/timeline/step_5.svg';
import Step6 from '../../../assets/novosicones/MeuImovel/timeline/step_6.svg';
import Step7 from '../../../assets/novosicones/MeuImovel/timeline/step_7.svg';

import { ReactSVG } from 'react-svg';

import './styles.scss';

const LinhaDoTempo = ({
  idEmpreendimentoImovelSelecionado,
  corEmpreendimento,
}) => {
  const [linhaDoTempo, setLinhaDoTempo] = useState([]);

  const [loadingLinhaDoTempo, setLoadingLinhaDoTempo] = useState(true);

  const [arquivos, setArquivos] = useState([]);

  const [arquivoAtual, setArquivoAtual] = useState('');

  const [tipoEmpreendimento, setTipoEmpreendimento] = useState('');

  const [etapaSelecionada, setNomeEtapaSelecionada] = useState({
    nome: '',
    icone: '',
  });

  const [etapaAtual, setEtapaAtual] = useState('');

  var classeDivisorEtapas = '';

  // useEffect(() => {
  //   if (idEmpreendimentoImovelSelecionado) loadTimeLine();
  // }, []);

  useEffect(() => {
    if (idEmpreendimentoImovelSelecionado) {
      setLoadingLinhaDoTempo(true);
      loadTimeLine();
      defineTipoEmpreendimento();
    }
  }, [idEmpreendimentoImovelSelecionado]);

  function defineTipoEmpreendimento() {
    if (corEmpreendimento == '#1D3054') {
      classeDivisorEtapas = 'passadoRiva';
      setTipoEmpreendimento('riva');
    } else {
      setTipoEmpreendimento('direcional');
    }
  }

  async function loadTimeLine() {
    let resultTimeline = await getTimeline(idEmpreendimentoImovelSelecionado);
    if (resultTimeline == false) {
      setLinhaDoTempo(0);
      setEtapaAtual(0);
    } else {
      setLinhaDoTempo(resultTimeline);
      setEtapaAtual(
        resultTimeline[resultTimeline.length - 1].Fase.split('-')[0]
      );
      loadArquivos(resultTimeline);
    }
    setLoadingLinhaDoTempo(false);
  }

  function loadArquivos(timeline) {
    let tempArquivos = [];
    timeline.forEach((fase) => {
      tempArquivos.push({
        fase: fase.Fase.split(' ')[0],
        arquivo: fase.ImagemUrl,
      });
    });
    setArquivos(tempArquivos);
  }

  function setArquivoFaseSelecionada(fase) {
    let resultFilter = arquivos.filter((arq) => {
      return arq.fase == fase;
    });
    setArquivoAtual(resultFilter[0]);
    setEtapaAtivada(fase);
  }

  function setEtapaAtivada(fase) {
    let result = Array.from(
      document.getElementsByClassName('linhaDoTempo__etapaPassada')
    );
    result.forEach((item) => {
      item.classList.remove('linhaDoTempo__etapaPassada--activeRiva');
      item.classList.remove('linhaDoTempo__etapaPassada--activeDirecional');
      if (item.accessKey == fase) {
        if (corEmpreendimento == '#003da5')
          item.classList.add('linhaDoTempo__etapaPassada--activeDirecional');
        else item.classList.add('linhaDoTempo__etapaPassada--activeRiva');
      }
    });
  }

  var etapas = [
    {
      etapaNumber: 1,
      nome: 'Eleição da comissão de representantes',
      icone: Step1,
    },
    { etapaNumber: 2, nome: 'Atualização de Fotos de Obra', icone: Step2 },
    { etapaNumber: 3, nome: 'Início de vistorias', icone: Step3 },
    { etapaNumber: 4, nome: 'Emissão do habite-se', icone: Step4 },
    { etapaNumber: 5, nome: 'Instalação do condomínio', icone: Step5 },
    { etapaNumber: 6, nome: 'Início de entrega de chaves', icone: Step6 },
    { etapaNumber: 7, nome: 'Averbação do habite-se', icone: Step7 },
  ];

  if (loadingLinhaDoTempo) return <Spinner />;

  return (
    <Fade in>
      <div>
        <div style={{ marginTop: '50px' }}>
          <div className='linhaDoTempo centralized'>
            <div className='inner centralized-space-between'>
              {etapas.map((etapa) => {
                return (
                  <>
                    {etapa.etapaNumber <= etapaAtual ? (
                      <>
                        <div
                          className={`centralized-column passado ${classeDivisorEtapas}`}
                          style={{ width: 'calc(100% / 7)' }}
                        >
                          <div className='centralized-column'>
                            <div
                              accessKey={etapa.etapaNumber}
                              key={etapa.etapaNumber}
                              className='linhaDoTempo__etapaPassada centralized-column'
                              onClick={() => {
                                setArquivoFaseSelecionada(etapa.etapaNumber);
                                setNomeEtapaSelecionada({
                                  nome: etapa.nome,
                                  icone: etapa.icone,
                                });
                              }}
                            >
                              <span
                                style={{
                                  backgroundColor: corEmpreendimento,
                                }}
                              >
                                <ReactSVG src={etapa.icone} />
                              </span>
                            </div>

                            <span
                              className='linhaDoTempo__nomeEtapaPassado'
                              style={{ color: corEmpreendimento }}
                            >
                              {etapa.nome}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className={`centralized-column futuro ${
                            etapaAtual == 0 ? 'futuro__inativo' : ''
                          }`}
                          style={{ width: 'calc(100% / 7)' }}
                        >
                          <div
                            key={etapa.etapaNumber}
                            className='linhaDoTempo__etapaFutura'
                          >
                            <span
                              style={{ backgroundColor: corEmpreendimento }}
                            >
                              <ReactSVG src={etapa.icone} />
                            </span>
                          </div>
                          <span
                            className='linhaDoTempo__nomeEtapaFuturo'
                            style={
                              etapaAtual == 0
                                ? { color: '#d1d1d1' }
                                : { color: corEmpreendimento }
                            }
                          >
                            {etapa.nome}
                          </span>
                        </div>
                      </>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          <div>
            <div
              className='centralized'
              style={{ justifyContent: 'flex-start', marginTop: '25px' }}
            >
              <div
                className={`linhaDoTempo__etapaPassada__${tipoEmpreendimento} centralized-column`}
                style={{ marginRight: '15px' }}
              >
                <span>
                  <ReactSVG src={etapaSelecionada.icone} />
                </span>
              </div>
              <p
                style={{
                  color: corEmpreendimento,
                  fontWeight: '900',
                }}
              >
                {etapaSelecionada.nome}
              </p>
            </div>
            {arquivoAtual != undefined &&
            arquivoAtual != null &&
            arquivoAtual.arquivo != undefined &&
            arquivoAtual.arquivo != null ? (
              <a href={arquivoAtual.arquivo} target='_blank' rel='noreferrer'>
                <img
                  src={arquivoAtual.arquivo}
                  alt=''
                  style={{
                    width: '150px',
                    height: '150px',
                    marginTop: '15px',
                  }}
                />
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
        {linhaDoTempo == 0 && (
          <p style={{ width: '100%', textAlign: 'center', fontWeight: '900' }}>
            Não foram encontradas fases na linha do tempo.
          </p>
        )}
      </div>
    </Fade>
  );
};

export default LinhaDoTempo;
